import { useContext, useEffect, useMemo, useRef, useState } from "react";

//CONSTANT & ASSETS
import { IMAGES } from "../assets";

//PACKAGES
import IconTint from "react-icon-tint";
import { ThemeContext } from "../context/ThemeProvider";
import { STRING } from "../constant";
import { AuthContext } from "../context/AuthProvider";
import { createLogger } from "../utils/logger";

function SpeedoMeter(props) {
  const { loggingEnabled } = useContext(AuthContext);
  const logger = createLogger(loggingEnabled);
  const { theme, currentTheme } = useContext(ThemeContext);
  logger.log("SpeedoMeter props:", props);
  logger.log("SpeedoMeter score:", props?.data?.readiness_score);

  const [angle, setAngle] = useState(0);
  const score = props?.data?.readiness_score;

  let scoreColor = '#c73938'; 
  if (score <= 16.66) {
    scoreColor = '#c73938';
  } else if (score <= 33.32) {
    scoreColor = '#eb4b3b';
  } else if (score <= 49.98) {
    scoreColor = '#f2940c';
  } else if (score <= 66.64) {
    scoreColor = '#f8ce18';
  } else if (score <= 83.3) {
    scoreColor = '#a2cb2d';
  } else {
    scoreColor = '#8ab712';
  }

  useEffect(() => {}, []);
  const rotationAngle = useMemo(() => {
    const percentage = Math.min(
      100,
      Math.max(0, props?.data?.readiness_score ?? 0)
    );

    if (percentage === 0) {
      setAngle(270);
      return 270;
    } else if (percentage <= 50) {
      setAngle(270 + (percentage / 50) * 90);
      return 270 + (percentage / 50) * 90;
    } else if (percentage === 51) {
      setAngle(360);
      return 360;
    } else {
      setAngle(360 + ((percentage - 51) / 49) * 89);
      return 360 + ((percentage - 51) / 49) * 89;
    }
  }, [props?.data?.readiness_score]);

  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };

  const getCardBackground = () => {
    return currentTheme === 'light' 
      ? theme?.homeCard?.start_light
      : theme?.homeCard?.start_dark;
  };

  return (
    <div
      key={props.type}
      className="relative z-[0] p-2 flex flex-col items-center justify-center mx-auto"
    >
      <div className="flex items-center justify-center mx-auto">
        <div className="relative w-[300px] h-[150px]">
          <img className="w-full h-full" src={IMAGES.ic_score_circle} alt="score circle" />
          <div className="text-center flex items-center justify-center">
            <div
              className="absolute bottom-[5%] h-[82%] w-[5px] bg-slate-300"
              style={{
                transform: `rotate(${angle}deg)`,
                transformOrigin: "bottom",
              }}
            />
            <svg
              className="absolute w-[30%] bottom-0 h-auto"
              viewBox="0 0 100 50"
              xmlns="http://www.w3.org/2000/svg"
              style={{ fill: scoreColor }}
            >
              <path d="M0,50 a50,50 0 0,1 100,0" />
            </svg>
            <span className="absolute bottom-[5%] text-white font-bold text-lg">
              {`${parseInt(props?.data?.readiness_score.toFixed() ?? 0)}%`}
            </span>
          </div>
        </div>
      </div>

      <div className="text-lg text-center mt-4 " style={{ color: getTextColor() }}>
        Overall Readiness Score
      </div>

      {props?.question && (
        <div className="flex items-center justify-center w-full gap-4 text-center mt-4" style={{ color: getTextColor() }}>
          <div
            className="flex flex-col items-center p-2 rounded-2xl w-32"
            style={{ backgroundColor: getCardBackground() }}
          >
            <p className="text-sm font-normal" style={{ color: getTextColor() }}>
              {STRING?.attempted}
            </p>
            <h2 className="font-medium" style={{ color: getTextColor() }}>
              {props?.question?.questions_answered}
            </h2>
          </div>
          <div
            className="flex flex-col items-center p-2 rounded-2xl w-32"
            style={{ backgroundColor: getCardBackground() }}
          >
            <p className="text-sm font-normal" style={{ color: getTextColor() }}>
              {STRING?.correct}
            </p>
            <h2 className="font-medium" style={{ color: getTextColor() }}>
              {props?.question?.questions_correct}
            </h2>
          </div>
          <div
            className="flex flex-col items-center p-2 rounded-2xl w-32"
            style={{ backgroundColor: getCardBackground() }}
          >
            <p className="text-sm font-normal" style={{ color: getTextColor() }}>
              {STRING?.incorrect}
            </p>
            <h2 className="font-medium" style={{ color: getTextColor() }}>
              {props?.question?.questions_incorrect}
            </h2>
          </div>
        </div>
      )}
    </div>
  );
}

export default SpeedoMeter;
